<form id="firmwareUpdateForm">
  <dialog-header>{{ data.isMultiple ? 'Update Multiple Displays Firmware' : 'Update WebOS Display Firmware' }}</dialog-header>

  <mat-dialog-content class="firmware-update-content">
    <!-- LG webOS Logo -->
    <div class="logo-container">
      <div class="lg-webos-logo">
        <span class="lg-red">LG</span>
        <span class="webos-text">webOS</span>
      </div>
    </div>

    <!-- Supporting Text -->
    <div class="supporting-text">
      You'll need the WebOS firmware file (.epk) hosted on Rise Vision Storage or your own HTTP server.
      For detailed steps on downloading, uploading, and applying firmware,
      <a href="https://help.risevision.com/user/firmware-update" target="_blank" class="instructions-link">view the full instructions.</a>
    </div>

    <!-- Form -->
    <div class="form-container">
      <label class="form-label">Firmware File URL (.epk)</label>
      <div class="input-frame">
        <input
          class="form-input"
          [formControl]="firmwareUrlControl"
          placeholder="http://www...epk"
          type="url">
      </div>
      <div class="error-message" *ngIf="firmwareUrlControl.invalid && firmwareUrlControl.touched">
        {{ getErrorMessage() }}
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="tw-gap-4">
    <div class="tw-flex-1">
      <button mat-stroked-button type="button" class="w-full" (click)="onCancel()">
        Cancel
      </button>
    </div>
    <div class="tw-flex-1">
      <button mat-flat-button type="button" color="primary" class="w-full" (click)="onUpdate()" [disabled]="firmwareUrlControl.invalid">
        Update Firmware
      </button>
    </div>
  </mat-dialog-actions>
</form>
